<template>
  <div class="wrap">
    <div class="contents_wrap type2">
      <section>
        <div class="login_box">
          <div class="left">
            <div class="login_logo">
              <h1>AICC Service</h1>
              <span>{{ $store.getters.contactCenterName }}</span>
            </div>
          </div>
          <div class="right">
            <h2>비밀번호 재설정 코드 전송</h2>
						<div class="form_box">
              <p class="login_txt">이메일을 입력해 주세요.</p>
							<div class="hbox jc">
                <ur-text-field v-model="otpSendAsk.loginId" placeholder="이메일 (email@address.com)" @keyup.enter="sendOtp" width="100%" />
							</div>
              <ur-button class="btn_login" :disabled="isDisabledBtn" @click="sendOtp" width="100%">재설정 코드 전송</ur-button>
						</div>
          </div>
        </div>
      </section>
      <!-- OTP Send Success Modal -->
      <ur-modal ref="successModal" :title="'확인'" small @closed="gotoResetPasswordPage()">
        <template>
          코드를 이메일로 보냈습니다.
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="confirmSuccess()" >확인</ur-button>
        </template>
      </ur-modal>
    </div>
  </div>
</template>

<script>
import ERROR_TYPE from '~common/js/error-type.js';
import AuthManager from '~system/auth/AuthManager';
import '~assets/css/aicc/home.css';/* css 파일 내 home_footer class 스타일을 가져오기 위한 import  */
import ReplyCode from '~modules/AI/js/ReplyCode.js';

export default {
  name: 'FindPassword',
  data() {
    return {
      otpSendAsk: {
        ccUrl: '',
        loginId: '',
        otpType: 'A',
      },
      loadingFlag: false,
    };
  },
  computed: {
    // 재설정 코드 받기 버튼 비활성화 여부
    isDisabledBtn() {
      if (!utils.isEmailFormat(this.otpSendAsk.loginId) || this.loadingFlag) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.$store.commit('hideGnbMenu');
    this.$store.commit('showFooter');
  },
  methods: {
    // 재설정 코드 발송
    sendOtp() {
      // validation check
      if (this.isDisabledBtn) {
        return;
      }
      this.loadingFlag = true; // 재설정 코드 받기 버튼 비활성화

      this.otpSendAsk.ccUrl = aiccUtils.urlUtil.getCcUrl();

      AuthManager.sendOtp(this.otpSendAsk).then(data => {
        if (data.reply.code === ReplyCode.NO_ERROR) { // 재설정 코드 발송 성공
          this.$store.commit('setLoginId', this.otpSendAsk.loginId);
          this.$store.commit('setOtpStartTime', new Date()); // 비밀번호 재설정 화면으로 바로 이동하지 않으므로, otp 발송 시간을 vuex에 저장
          this.$refs.successModal.open();
        } else { // 재설정 코드 발송 실패
          this.loadingFlag = false; // 재설정 코드 받기 버튼 활성화
          utils.aiccMessageBox('확인', data.reply.korMsg, '확인');
        }
      }).catch(err => { // 재설정 코드발송 실패
        this.loadingFlag = false; // 재설정 코드 받기 버튼 활성화

        if (err.errorType === ERROR_TYPE.BIZ) { // 유저 상태 오류
          utils.aiccMessageBox('확인', err.errorMessage, '확인');
        } else {
          console.warn(err);
        }
      });
    },

    // 재설정 코드 발송 성공 확인
    confirmSuccess() {
      this.$refs.successModal.close();
    },

    gotoResetPasswordPage() {
      this.$router.replace('/ResetPassword');
    }
  },
};
</script>

<style scoped>
/* ======== container ========= */
.wrap {background-color:#f7f7f7; display: flex; justify-content: center; align-items: center;}

/* ========== button ========== */
.login_box .btn_login {display: block; width: 100%; height: 48px;line-height: 46px; margin-top:24px; background-color:#516af4; font-size: 18px; color:#fff; text-align: center; border: none;}
.login_box .btn_login:hover {background-color:#516af4;}
.login_box .ur-button--disabled {background-color: #f7f7f7 ;color:#a5a5a5;}
</style>
